export const GET_TUNES = "GET_TUNES";
export const GET_TUNE_BY_ID = "GET_TUNE_BY_ID";
export const UPDATE_TUNE = "UPDATE_TUNE";
export const DELETE_TUNE = "DELETE_TUNE";
export const CREATE_TUNE = "CREATE_TUNE";
